// extracted by mini-css-extract-plugin
export default {"scrollContainer":"scroller_scrollContainer__AvKE-","spacer":"scroller_spacer__8-l9L","up":"scroller_up__3k8cU","down":"scroller_down__oqMj1","active":"scroller_active__nt2cd"};